<template>
  <div class="tab-content">
    <div v-if="showSignedHistory">
      <SectionTitle
        v-if="!isPs"
        content="Historial de Firma"
        :has-line="true"
        container-class="mt-4 "
      />
      <SignatureHistory
        :listOfSignatures="signatureHistoryList"
        :options="availableSignatureOptions"
      />
      <ParticipantSignatures
        ref="ParticipantSignatures"
        :key="componentKey"
        :onlyMinutaAndSignPei="true"
        :validate="validateForm"
        :listOfSignatures="signatureList"
        :signatureFiles="signatureFiles"
        :signature-types="signatureTypes"
        :documentDigital="document"
        :showOptionDigitalSignature="enableOption"
        :allTypesAreElectronic="allTypesAreElectronic"
        :atLeastOneIsElectronic="atLeastOneIsElectronic"
        @document-list="getDocumentList"
        @refreshdocuments="getTabInfo"
      />
    </div>
    <div v-else class="main-content">
      <signature-cancellation
        v-if="showSignatureCancellationDocument"
        class="my-3"
        @refresh-digital-signature="onRefreshDigitalSignatureHandler"
      />
      <ValidationObserver ref="formValidator" v-slot="{ dirty }">
        <form novalidate>
          <div class="col-12 pl-0 pr-0">
            <div v-if="readOnly">
              <SectionTitle
                v-if="document.createdByName"
                icon="fas fa-info-circle"
                content="Información del Documento"
                container-class="mt-4 mb-2"
                reverse
              />
              <div
                v-if="document.createdByName"
                class="bg-secondary-3 rounded my-2 py-4 px-5 my-4"
              >
                <div class="row">
                  <div class="col-12 col-md-3">
                    <label class="text-gray font-14 ml-n1">
                      <i class="fas fa-file-alt text-orange mr-2"></i>
                      Documento creado por:
                    </label>
                    <p class="font-16 ml-3">
                      {{ document.createdByName }}
                    </p>
                  </div>
                  <div class="col-12 col-md-3">
                    <label class="text-gray font-14 ml-n1">
                      <i class="fas fa-user-circle text-orange mr-2"></i>
                      Puesto:
                    </label>
                    <p class="font-16 ml-3">
                      {{ document.createdByRole }}
                    </p>
                  </div>
                  <div class="col-12 col-md-3">
                    <label class="text-gray font-14">
                      <i class="fas fa-file-signature text-orange mr-2"></i>
                      Propósito del documento:
                    </label>
                    <p class="font-16 ml-4">
                      {{ document.documentPurpose }}
                    </p>
                  </div>
                  <div class="col-12 col-md-3">
                    <label class="text-gray font-14 ml-n1">
                      <i class="fas fa-calendar-edit text-orange mr-2"></i>
                      Creado el:
                    </label>
                    <p class="font-16 ml-3">
                      {{ document.createdAt | date }}
                    </p>
                  </div>
                </div>
              </div>

              <Tab10ListOfParticipants
                :listOfPaticipants="participantsForList"
                :listOfSignatures="signatureList"
                :documentId="document.documentId"
                @reload="getDocumentSignature"
              />
              <ParticipantSignatures
                ref="ParticipantSignatures"
                :key="componentKey"
                :onlyMinutaAndSignPei="true"
                :validate="validateForm"
                :listOfSignatures="signatureList"
                :signatureFiles="signatureFiles"
                :signature-types="signatureTypes"
                :documentDigital="document"
                :showOptionDigitalSignature="enableOption"
                :allTypesAreElectronic="allTypesAreElectronic"
                :atLeastOneIsElectronic="atLeastOneIsElectronic"
                @document-list="getDocumentList"
                @refreshdocuments="getTabInfo"
              />
            </div>
            <div v-else>
              <div v-if="documentCancellationDetail" class="mt-3">
                <SectionTitle
                  :is-big-icon="true"
                  icon="fas fa-times-circle  fa-fw"
                  content="Detalles Cancelación de Firmas"
                  reverse
                />
                <div class="row mx-3">
                  <div class="col-12 col-md-6">
                    <label class="text-gray font-14">
                      <i class="fas fa-file-signature text-orange mr-2" />
                      Razón de cancelación:
                    </label>
                    <p class="font-16 ml-4">
                      {{ documentCancellationDetail.reason }}
                    </p>
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="text-gray font-14">
                      <i class="fas fa-file-signature text-orange mr-2" />
                      Fecha de Cancelación:
                    </label>
                    <p class="font-16 ml-4">
                      {{ documentCancellationDetail.date | date }}
                    </p>
                  </div>
                </div>
              </div>
              <SectionTitle
                icon="fas fa-user-edit"
                content="Participantes"
                container-class="mt-4 mb-2"
                reverse
              />
              <ParticipantSignatures
                ref="ParticipantSignatures"
                :key="componentKey"
                :validate="validateForm"
                :listOfSignatures="signatureList"
                :signatureFiles="signatureFiles"
                :signature-types="signatureTypes"
                :documentDigital="document"
                :showOptionDigitalSignature="enableOption"
                :allTypesAreElectronic="allTypesAreElectronic"
                :atLeastOneIsElectronic="atLeastOneIsElectronic"
                @document-list="getDocumentList"
                @refreshdocuments="getTabInfo"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';
import ParticipantSignatures from '@/components/pei/tabs/components/tab10/Tab10ParticipantSignatures';
import Tab10ListOfParticipants from '@/components/pei/tabs/components/tab10/Tab10ListOfParticipants';
import SignatureCancellation from '@/components/pei/tabs/components/tab10/SignatureCancellation.vue';
import peiStatuses from '@/utils/constants/pei/peiStatus';
import signatures from '@/services/signatures';
import { SignatureTypes } from '@/utils/constants/signature/signatureTypes';
import { mapGetters, mapState } from 'vuex';
import SignatureHistory from '@/components/pei/SignatureHistory.vue';
import signatureService from '@/modules/common/signature.api';
import { mapMutations } from 'vuex';
import { SignatureStatus } from '@/utils/constants/signature/signatureStatus.js';
import { documentStatuses } from '@/utils/constants/signature/statusDocumentSignature';
import objectToFormData from 'object-to-formdata';
import { getDeviceInformation } from '@/utils/deviceInfoUtil';
export default {
  name: 'Tab10',
  mixins: [mixAlert],
  components: {
    SignatureHistory,
    SectionTitle,
    ValidationProvider,
    ValidationObserver,
    ParticipantSignatures,
    Tab10ListOfParticipants,
    SignatureCancellation,
  },
  data() {
    return {
      showCommentForAgencyIds: [],
      Info: {},
      isPs: store.getters.getIsPs,
      peiStatus: store.getters.SelectedPeiStatus,
      peiStatuses: peiStatuses,
      disabledDatesFrom: new Date(),
      errorMessage: '',
      resources: [],
      isCurrentStepValid: true,
      isCurrentStepValidProgress: true,
      selectedStudent: store.getters.SelectedStudent,
      currentPeiStatus: store.getters.SelectedPeiStatus,
      componentKey: 0,
      modelInfo: {
        signatures: [],
        isPSSignatureFilesFlag: null,
      },
      signatureList: [],
      signatureFiles: {
        compuMinutes: {
          fileId: null,
          fileName: null,
          file: null,
        },
        signedPei: {
          fileId: null,
          fileName: null,
          file: null,
        },
        signedSaee10: {
          fileId: null,
          fileName: null,
          file: null,
        },
      },
      signatureHistoryList: [],
      availableSignatureOptions: [],
      signatureTypes: [],
      showFooterBar: false,
      prevScrollpos: window.pageYOffset,
      getParticipantSignatures: false,
      observers: {},
      signatureOptionIsEnable: false,
      signatureDocument: {
        createdByName: null,
        createdByRole: null,
        documentPurpose: null,
        createdAt: null,
        documentId: null,
        statusId: null,
        participants: [],
      },
      validate: false,
      documentCancellationDetail: null,
      documentList: [],
      canShowRefreshSignatureTab: store.getters.canShowRefreshSignatureTab,
      deviceInformation: {
        ip: null,
        browser: null,
        engine: null,
        device: null,
        os: null,
      },
    };
  },
  methods: {
    ...mapMutations([
      'setShowRefreshSignatureTab',
      'setShowDigitalSignatureActions',
      'setSignatureDocument',
      'setIsDigitalSignatureCancelled',
      'setTab10SignatureInfo',
    ]),
    updateComponent() {
      this.componentKey = this.componentKey == 0 ? 1 : 0;
    },
    async setDeviceInformation() {
      this.deviceInformation = await getDeviceInformation();
    },
    async getDocumentSignature(showSuccess = false) {
      await this.getTabInfo();

      if (showSuccess) {
        this.ShowToast(
          'Proceso exitoso',
          'Se actualizaron las firmas exitosamente.',
          'success'
        );
      }
    },
    async getSignatureTypes() {
      const res = await signatures.getAllSignatureTypes();
      this.signatureTypes = res.data;
    },
    async getTabInfo() {
      try {
        const { data: response } = await this.$ApiGet(
          `/api/pei/signaturetab?peiId=${this.peiId}`
        );
        this.modelInfo = response;
        const isElectronicSignature = (response?.signatures || []).some(
          (signature) =>
            signature.requireSignature &&
            Number(signature.signatureTypeId) === SignatureTypes.email
        );
        this.setTab10SignatureInfo({
          isPSSignatureFilesFlag: response?.isPSSignatureFilesFlag ?? null,
          isElectronicSignature,
        });
        this.signatureFiles = response.signatureFiles;
        this.signatureList = response.signatures.map((s) => ({
          peiSignatureId: s.id,
          fullName: s.fullName,
          positionName: s.positionName,
          positionCode: s.positionCode,
          requireSignature: s.requireSignature,
          isDocumentRequired: s.isDocumentRequired,
          participationTypeText: s.participationTypeText,
          hasSae08a: s.hasSae08a,
          hasSae08aDocumentId: s.hasSae08aDocumentId,
          fileNameText: s.fileNameText,
          originalSignatureTypeId: s.signatureTypeId,
          originalEmail: s.email,
          model: {
            email: s.email,
            type:
              this.signatureTypes.find((t) => t.id === s.signatureTypeId) ??
              null,
            typeId: s.signatureTypeId,
          },
        }));

        // El backend incluye digitalSignatureDocument + documentCancellationDetail
        // en el mismo endpoint para evitar llamadas separadas.
        const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
        const documentId = response.digitalSignatureDocument?.documentId;
        const hasDigitalDocument = !!documentId && documentId !== EMPTY_GUID;
        const documentStatusId = response.digitalSignatureDocument?.statusId;
        const hasActiveDigitalDocument =
          hasDigitalDocument && documentStatusId !== documentStatuses.Cancelled;

        this.signatureDocument = response.digitalSignatureDocument || {
          createdByName: null,
          createdByRole: null,
          documentPurpose: null,
          createdAt: null,
          documentId: null,
          statusId: null,
          participants: [],
        };
        this.setSignatureDocument(this.signatureDocument);

        const hasCancellationDetail = !!response.documentCancellationDetail?.reason;
        const isDigitalSignatureCancelled =
          documentStatusId === documentStatuses.Cancelled ||
          (hasCancellationDetail && !hasActiveDigitalDocument);

        this.documentCancellationDetail = isDigitalSignatureCancelled
          ? response.documentCancellationDetail
          : null;
        this.setIsDigitalSignatureCancelled(isDigitalSignatureCancelled);

        this.setShowRefreshSignatureTab(hasActiveDigitalDocument);

        const areAllSigned =
          (response.digitalSignatureDocument?.participants || []).length > 0 &&
          response.digitalSignatureDocument?.participants?.every(
            (x) => x.signatureStatusId === SignatureStatus.Signed
          ) || false;
        await this.setShowDigitalSignatureActions(
          hasActiveDigitalDocument && !areAllSigned
        );

        await this.setDeviceInformation();
      } catch (err) {
        this.response = err;
      }
    },
    async getSignatureTabIsEnable() {
      this.signatureOptionIsEnable = store.getters.getPeiInfo.tab10IsEnabled;
    },
    getDocumentList(docList) {
      this.documentList = docList;
    },
    // Save.
    async save() {
      await this.handleSubmit();
    },
    async handleSubmit() {
      this.validate = true;
      let isValid = (await this.$refs.formValidator?.validate()) ?? true;
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      if (!this.allTypesAreElectronic && !store.getters.justSaveTab10) {
        this.ShowToast(
          'Alerta',
          'Todas las firmas deben ser firma electrónica.',
          'error'
        );
        return;
      }

      const payload = {
        studentName: this.student.fullName,
        relatedId: this.peiId,
        justSaveFlag: store.getters.justSaveTab10,
        isPS: this.isPs,
        documents: this.documentList,
        listOfParticipants: this.signatureRequired.map((e) => {
          return {
            peiSignatureId: e.peiSignatureId,
            Name: e.fullName,
            Email: e.model.email,
            SignatureTypeId: e.model.typeId ?? e.model.type?.id,
            Position: e.positionName,
          };
        }),
        ip: this.deviceInformation.ip,
        browser: this.deviceInformation.browser,
        engine: this.deviceInformation.engine,
        device: this.deviceInformation.device,
        os: this.deviceInformation.os,
      };
      const formData = objectToFormData(payload, { indices: true });
      let index = 0;
      payload.documents.forEach((element) => {
        formData.append(`documents[${index}].file`, element.file);
        formData.append(`documents[${index}].idSignature`, element.idSignature);
        index++;
      });

      await this.$refs['ParticipantSignatures'].upsertSignFiles(this.peiId);

      const { data } = await signatures
        .createDigitalSignatureDocument(formData)
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast(
              'Error',
              'Ha ocurrido un error inesperado.',
              'error'
            );
          }
        });

      if (data) {
        const message = store.getters.justSaveTab10
          ? 'La información ha sido guardada exitosamente.'
          : 'Documento creado exitosamente.';
        this.ShowToast('Proceso exitoso', message, 'success');
      }
      await this.getTabInfo();

      if (
        this.modelInfo.signatureFiles.compuMinutes.fileId != null &&
        this.modelInfo.signatureFiles.signedPei.fileId != null
      ) {
        await this.$store.dispatch(
          'setSelectedPeiStatusDescription',
          store.getters.SelectedPeiStatus == peiStatuses.Firmado
            ? 'Firmado'
            : store.getters.SelectedPeiStatus ==
              peiStatuses.PartialSignedPendingFunds
            ? 'Firmado Parcial - Pendiente de Fondos'
            : store.getters.SelectedPeiStatus ==
              peiStatuses.SignedWithControversy
            ? 'Firmado - Controversia'
            : ''
        );
      }

      this.updateComponent();
    },
    async getAvailableSignatureOptions() {
      let self = this;
      let promise = new Promise((resolve) => {
        self.$ApiGet('/api/signature/availablepositionsTab9').then((res) => {
          self.availableSignatureOptions = res.data;
          resolve(res.data);
        });
      });

      return promise;
    },
    loadSignatures() {
      let self = this;
      this.modelInfo.signatures.forEach((signature) => {
        if (!self.signatureHistoryList.some((x) => x.id == signature.id)) {
          self.signatureHistoryList.push({
            id: signature.id,
            name: signature.fullName,
            position: {
              signaturePositionId: signature.positionCode,
              signaturePositionName: signature.positionName,
            },
            signatureType: {
              id: signature.signatureTypeId,
              name: this.signatureTypes.find(
                (item) => item.id === signature.signatureTypeId
              )?.name,
            },
            signatureDate: signature.signatureDate,
            groupId: 0,
          });
        }
      });
    },
    getBasicSignature(groupId, removable = false) {
      let signature = this.modelInfo.signatures.find((x) =>
        this.availableSignatureOptions.some(
          (y) =>
            y.signatureGroupId == groupId &&
            y.signaturePositionId == x.positionCode
        )
      );
      if (signature != undefined) {
        return {
          id: signature.id,
          name: signature.fullName,
          position: {
            signaturePositionId: signature.positionCode,
            signaturePositionName: signature.positionName,
          },
          signatureType: {
            id: signature.signatureTypeId,
            name: this.signatureTypes.find(
              (item) => item.id === signature.signatureTypeId
            )?.name,
          },
          signatureDate: signature.signatureDate,
          groupId: groupId,
        };
      } else {
        if (this.isDraft) {
          this.signatureCounter -= 1;
          return {
            id: this.signatureCounter,
            signature: {
              name: '',
              position: undefined,
              signatureType: undefined,
            },
            groupId: groupId,
          };
        }
      }
    },
    async validatePlacementInfo() {
      await this.$ApiGet(`/api/pei/${this.peiId}/validatePlacementInfo`)
        .then((res) => {
          this.validPlacement = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async setSignatureConfig() {
      await this.validatePlacementInfo();
      if (this.validPlacement != true && this.isDraft) {
        return;
      }

      this.getAvailableSignatureOptions();

      let signatureConfig = [];
      await signatureService
        .getDefaultConfiguration(this.peiId, this.selectedStudent.studentId)
        .then((result) => {
          signatureConfig = result.data;
        });
      this.signatureHistoryList = [];

      if (signatureConfig.length > 0) {
        this.signatureInfoMessage = signatureConfig.find(
          (e) => e.name != ''
        )?.name;
        signatureConfig.forEach((config) => {
          let groupId = config.id;
          let signatures = this.modelInfo.signatures
            .filter((x) =>
              this.availableSignatureOptions.some(
                (y) =>
                  y.signatureGroupId == groupId &&
                  y.signaturePositionId == x.positionCode
              )
            )
            ?.map((signature) => {
              if (!signature && this.isDraft) {
                this.signatureCounter -= 1;
                return {
                  id: this.signatureCounter,
                  signature: {
                    name: '',
                    position: undefined,
                    signatureType: undefined,
                  },
                  groupId: groupId,
                };
              }

              if (signature) {
                return {
                  id: signature.id,
                  name: signature.fullName,
                  position: {
                    signaturePositionId: signature.positionCode,
                    signaturePositionName: signature.positionName,
                  },
                  signatureType: {
                    id: signature.signatureTypeId,
                    name: this.signatureTypes.find(
                      (item) => item.id === signature.signatureTypeId
                    )?.name,
                  },
                  signatureDate: signature.signatureDate,
                  groupId: groupId,
                };
              }
            });

          (signatures ?? []).forEach((signature) => {
            this.signatureHistoryList.push(signature);
          });
        });
      } else {
        this.signatureHistoryList = [];
        //getting default Signatures
        let signature1 = this.getBasicSignature(1);
        if (signature1 != undefined) {
          this.signatureHistoryList.push(signature1);
        }

        let signature5 = this.getBasicSignature(5);
        if (signature5 != undefined) {
          this.signatureHistoryList.push(signature5);
        }

        let signature6 = this.getBasicSignature(4);
        if (signature6 != undefined) {
          this.signatureHistoryList.push(signature6);
        }
      }
      this.loadSignatures();
    },
    async onRefreshDigitalSignatureHandler() {
      this.$emit('refresh-digital-signature');
    },
  },
  computed: {
    ...mapGetters({
      student: 'SelectedStudent',
    }),
    ...mapState({
      showSignatureCancellationDocument: (state) =>
        state.pei.showSignatureCancellationDocument,
      isDigitalSignatureCancelled: (state) =>
        state.pei.isDigitalSignatureCancelled,
    }),
    document() {
      return this.signatureDocument;
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatuses.Borrador;
    },
    validateForm() {
      return this.validate;
    },
    ValidationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    peiId() {
      return this.$store.state.peiSelected;
    },
    enableOption() {
      return this.signatureOptionIsEnable;
    },
    allTypesAreElectronic() {
      const types = this.signatureRequired.map((e) => e.model.type);
      return types?.every((s) => s && s.id == SignatureTypes.email);
    },
    atLeastOneIsElectronic() {
      const types = this.signatureRequired.map((e) => e.model.type);
      return types.some((s) => s && s.id == SignatureTypes.email);
    },
    readOnly() {
      return this.hasDigitalDocument;
    },
    hasDigitalDocument() {
      if (this.isDigitalSignatureCancelled) return false;
      const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
      return (
        !!this.document?.documentId &&
        this.document.documentId !== EMPTY_GUID &&
        this.document.statusId !== documentStatuses.Cancelled
      );
    },
    participantsForList() {
      if (Array.isArray(this.document?.participants) && this.document.participants.length > 0) {
        return this.document.participants;
      }

      if (!this.hasDigitalDocument) {
        return [];
      }

      return this.signatureList.map((signature) => ({
        fullName: signature.fullName,
        position: signature.positionName,
        email: signature.model?.email,
        username: null,
        signatureStatusId: null,
        userId: null,
      }));
    },
    showSignedHistory() {
      return (
        ([peiStatuses.Firmado].includes(
          store.getters.SelectedPeiStatus.toString()
        ) &&
          !this.isPs) ||
        (this.isPs && this.modelInfo?.isPSSignatureFilesFlag === false)
      );
    },
    signatureRequired() {
      return this.signatureList.filter((x) => x.requireSignature);
    },
  },
  async activated() {
    await Promise.all([
      this.$store.commit('setSaveBtnVisibility', false),
      this.$store.commit('setSaveMethod', this.handleSubmit),
      this.$store.commit('setResetOriginalDataMethod', () => {}),
      this.getSignatureTypes(),
      this.getTabInfo(),
      this.getSignatureTabIsEnable(),
    ]);

    this.Info = this.$attrs.Info;

    if (this.showSignedHistory) {
      await this.setSignatureConfig();
    }

    this.updateComponent();
  },
};
</script>

<style scoped>
.info-tab p {
  text-align: left;
  font: Bold 14px/17px Lato;
  color: #727272;
  opacity: 1;
}
.main-content {
  margin: 0px;
  padding: 0px;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.text-bold {
  font-weight: 600 !important;
}
.content-table-striped {
  margin-top: 0px;
}
.td-row-space {
  width: 90% !important;
}
.footer-success {
  margin: 8px;
  padding: 5px 10px;
}
.mt-neg-16 {
  margin-top: -16px !important;
}
.mb-neg-4 {
  margin-bottom: -4px !important;
}
.mb-neg-35 {
  margin-bottom: -35px !important;
}
.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0);
}
.no-border-top {
  border-top: none !important;
}
</style>
